<template>
  <div class="auth-input-wrapper">
    <input
      :class="{error: !credentialsValid}"
      @input="clearErrors"
      v-model="value"
      type="text"
      id="login-email"
      maxlength="35"
      required
    >
    <label for="login-email">E-mail</label>
  </div>
</template>

<script>
export default {
  name: 'EmailLoginInput',
  computed: {
    value: {
      get() {
        return this.$store.getters.loginEmail;
      },
      set(value) {
        this.$store.commit('updateLoginEmail', value);
      }
    },
    credentialsValid() {
      return this.$store.getters.loginCredentialsValid;
    }
  },
  methods: {
    clearErrors() {
      this.$store.dispatch('clearAllAuthErrors');
    }
  }
};
</script>
